import React from 'react';
import { motion } from 'framer-motion';
import Hero from '../components/Hero';
import ProblemSection from '../components/ProblemSection';
import ExpertsSection from '../components/ExpertsSection';
import ProgramOverview from '../components/ProgramOverview';
import MethodologySection from '../components/MethodologySection';
import EMDRSection from '../components/EMDRSection';
import TestimonialsSection from '../components/TestimonialsSection';
import ProgramDetails from '../components/ProgramDetails';
import FAQSection from '../components/FAQSection';
import UrgencyBanner from '../components/UrgencyBanner';
import CTASection from '../components/CTASection';
import Footer from '../components/Footer';

const Home = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
      className="min-h-screen"
    >
      <Hero />
      <ProblemSection />
      <ExpertsSection />
      <ProgramOverview />
      <MethodologySection />
      <EMDRSection />
      <TestimonialsSection />
      <ProgramDetails />
      <FAQSection />
      <UrgencyBanner />
      <CTASection />
      <Footer />
    </motion.div>
  );
};

export default Home;